<template>
    <div class="wrapper">
        <div class="header-slot">
            <slot name="header" />
        </div>
        <v-divider class="middle-divider"></v-divider>
        <div class="content-slot">
            <slot name="content" />
        </div>
    </div>
</template>

<style lang="scss">

.wrapper{
    height: 100%;
    margin: 1vh 3vw 5vh 3vw;
    display: grid;
    grid-template-rows: 1fr auto 2.9fr;
}
.header-slot{
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.content-slot{
    margin-top: 2vh;
}
.middle-divider{
    border: 6px solid $font-color !important;
    background-color: $font-color !important;
    border-radius: 6px;
}
</style>

<script>
export default {

}
</script>
